module.exports = __webpack_public_path__ + "img/history_icon.fc7426b3.svg";